import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-create-in-progress',
  templateUrl: './create-in-progress.component.html',
  styleUrls: ['./create-in-progress.component.scss']
})
export class CreateInProgressComponent implements OnInit {
  @Input() routeName: string;
  @Input() projectName: string;

  constructor() { }

  ngOnInit() {
  }

  hasProject(): boolean {
    if (this.projectName) {
      return true;
    }
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/new-route/components/create-in-progress/create-in-progress.component.ts